export default "__VITE_ASSET__9dc363ba__"